import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles/index';
import SwipeableViews from 'react-swipeable-views';
import Tabs, {Tab} from 'material-ui/Tabs/index';
import CardLayout from "components/CardLayout";
import UserList from "./UserList";
import CardMenu from "components/dashboard/Common/CardMenu";

import {get} from 'engine/dataServices';


function TabContainer({children, dir}) {
    return (
        <div dir={dir}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

class FavoriteProducers extends Component {

    handleChange = (event, value) => {
        this.setState({value});
    };

    handleChangeIndex = index => {
        this.setState({value: index});
    };

    constructor() {
        super();
        this.state = {
            value: 0,
            topSalesData: [],
            topFollowersData: [],
        }
    }

    componentWillMount() {
        this.loadTopSales();
        this.loadTopFollowers();
    }

    async loadTopSales() {
        const res = await get('Producer/GetTopSales');
        if (res.status == 200) {
            const responseData = await res.json();
            const _data = [];

            responseData.map(x => {
                _data.push({
                    id: x.Id,
                    title: x.Name,
                    image: x.Image,
                    desc: `مبلغ ${x.Count.toLocaleString()} تومان فروش`
                })
            });

            this.setState({topSalesData: _data});
        }
    }

    async loadTopFollowers() {
        const res = await get('Producer/GetTopFollowers');
        if (res.status == 200) {
            const responseData = await res.json();
            const _data = [];

            responseData.map(x => {
                _data.push({
                    id: x.Id,
                    title: x.Name,
                    image: x.Image,
                    desc: `تعداد ${x.Count.toLocaleString()} دنبال کننده`
                })
            });

            this.setState({topFollowersData: _data});
        }
    }

    render() {
        const {topSalesData, topFollowersData} = this.state;
        const {theme} = this.props;

        return (
            <CardLayout styleName="col-lg-12">
                <div className="jr-card-header mb-3 d-flex align-items-center">
                    <div className="">
                        <h3 className="card-heading mb-0">
                            <i className="zmdi zmdi-store ml-2"/>
                            فروشندگان برتر
                        </h3>
                    </div>
                </div>

                <div className="tab-notifications">
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        fullWidth
                    >
                        <Tab className="tab" label="بیشترین فروش"/>

                        <Tab className="tab" label="بیشترین دنبال کننده"/>
                    </Tabs>
                </div>

                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={this.state.value}
                    onChangeIndex={this.handleChangeIndex}
                >
                    <TabContainer dir={theme.direction}>
                        <UserList users={topSalesData}/>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <UserList users={topFollowersData}/>
                    </TabContainer>

                </SwipeableViews>
            </CardLayout>

        );
    }
}

FavoriteProducers.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(FavoriteProducers);


// WEBPACK FOOTER //
// ./components/toliton/desktop/producers/favoriteProducers.js